export const sellingFrequency = [
  {
    label: 'Never',
    value: 'never',
  },
  {
    label: 'Sometimes',
    value: 'sometimes',
  },
  {
    label: 'Often',
    value: 'often',
  },
  {
    label: 'Always',
    value: 'always',
  },
];

export default sellingFrequency;
